import React from "react";
import Countdown from "react-countdown";
import { Link } from "react-router-dom";
import { HangUpIcon } from "@100mslive/react-icons";
import {
  Box,
  Flex,
  Footer as AppFooter,
  IconButton,
  styled,
  Tooltip,
} from "@100mslive/roomkit-react";
import { LogoIcon } from "../../icons";
import { Header } from "../Header";

const EventWatingLayout = props => {
  const {
    eventName,
    hostedBy,
    eventStartTime,
    eventDate,
    counterRender,
    onClose,
  } = props;

  const LeaveIconButton = styled(IconButton, {
    color: "$white",
    h: "$14",
    px: "$8",
    r: "$1",
    bg: "$error",
    "&:not([disabled]):hover": {
      bg: "$errorTint",
    },
    "&:not([disabled]):active": {
      bg: "$errorTint",
    },
    "@md": {
      px: "$4",
      mx: 0,
    },
  });

  return (
    <React.Fragment>
      <Flex className="attendee-area-col-watingroom">
        <Box
          className="attendee-area-col-watingroom-header"
          css={{ h: "$18", "@md": { h: "$17" } }}
          data-testid="header"
        >
          <Header />
        </Box>

        <Flex className="attendee-area-col-watingroom-body">
          <div className="attendee-area-col-watingroom-body-content">
            <div className="attendee-area-col-watingroom-body-content-title">
              {eventName}
            </div>
            {hostedBy?.length > 0 ? (
              <div className="attendee-area-col-watingroom-body-content-hostedby">
                <div className="attendee-area-col-watingroom-body-content-hostedby-text">
                  Hosted by
                  {hostedBy.map((item, key) => {
                    return (
                      <span key={key}>
                        <Link
                          title={item?.orgName}
                          to={
                            item?.orgSlug ? `/company/${item?.orgSlug}` : null
                          }
                          key={key}
                          className="text-link"
                        >
                          <b> {item?.orgName}</b>
                        </Link>
                        {key !== hostedBy.length - 1 ? <>,</> : null}
                      </span>
                    );
                  })}
                </div>
                <div className="attendee-area-col-watingroom-body-content-hostedby-logo">
                  {hostedBy.map((item, key) => {
                    return (
                      <Link
                        title={item?.orgName}
                        to={item?.orgSlug ? `/company/${item?.orgSlug}` : null}
                        key={key}
                        className="attendee-area-col-watingroom-body-content-hostedby-logo-img"
                        style={{ backgroundColor: item?.orgLogoColor }}
                      >
                        {item?.orgLogo ? (
                          <img
                            src={item?.orgLogo}
                            alt={`Logo - ${item?.orgName} `}
                            width={50}
                            height={50}
                          />
                        ) : (
                          <LogoIcon />
                        )}
                      </Link>
                    );
                  })}
                </div>
              </div>
            ) : null}

            <div className="attendee-area-col-watingroom-body-content-line"></div>

            <Flex
              justify="center"
              className="attendee-area-col-watingroom-body-content-counter"
            >
              {eventStartTime && eventDate ? (
                <Countdown date={eventStartTime} renderer={counterRender} />
              ) : null}
            </Flex>
          </div>
        </Flex>

        <Box css={{ flexShrink: 0, minHeight: "$24" }} data-testid="footer">
          <AppFooter.Root className="preview_tile_footer" translate="no">
            <AppFooter.Center className="preview_tile_footer_col">
              <div className="preview_tile_footer_frame">
                <LeaveIconButton
                  onClick={onClose}
                  variant="danger"
                  key="LeaveRoom"
                  data-testid="leave_room_btn"
                >
                  <Tooltip title="Leave wating room">
                    <Box>
                      <HangUpIcon key="hangUp" />
                    </Box>
                  </Tooltip>
                </LeaveIconButton>
                <span className="preview_tile_footer_indicator">End Call</span>
              </div>
            </AppFooter.Center>
          </AppFooter.Root>
        </Box>
      </Flex>
    </React.Fragment>
  );
};

export default EventWatingLayout;
